<template>
    <div class="tw:min-h-[calc(100vh-255px)]">
        <ListWrapper
            :loading="loading"
            :error="error"
            :is-empty="parcelas.length === 0"
            :meta="meta"
            :page="page"
            :per-page="perPage"
            @fetch="fetchParcelas($event, perPage)"
            @fetch-per-page="newPerPage => fetchParcelas(1, newPerPage)"
        >
            <template #error="{ error: err }">
                <div class="tw:bg-red-50 tw:border tw:border-red-200 tw:text-red-800 tw:px-4 tw:py-3 tw:rounded-lg">
                    <p class="tw:font-bold">{{ $t('perfil.parcelas_error_cargar') }}</p>
                    <p class="tw:text-sm tw:text-black">{{ err?.message || $t('perfil.error_desconocido') }}</p>
                </div>
            </template>

            <template #filters>
                <CardFront custom-classes="tw:mb-3 tw:py-4 tw:px-4">
                    <InputText
                        v-model="search"
                        :label="$t('perfil.parcelas_buscar')"
                    />
                </CardFront>
            </template>

            <template #empty>
                <CardFront custom-classes="tw:py-16 tw:text-center tw:items-center">
                    <i class="material-icons tw:text-5xl tw:text-slate-300">grid_on</i>
                    <p class="tw:mt-4 tw:font-semibold tw:text-slate-700">{{ $t('perfil.parcelas_vacio_titulo') }}</p>
                    <p class="tw:text-sm tw:text-slate-400 tw:mt-1">{{ $t('perfil.parcelas_vacio_descripcion') }}</p>
                </CardFront>
            </template>

            <ParcelaCard v-for="parcela in parcelas" :key="parcela.n_pedido" :parcela="parcela" />
        </ListWrapper>
    </div>
</template>

<script setup>
    import { onMounted } from 'vue';
    import { useParcelas } from '@/composables/front/perfil/useParcelas';
    import CardFront from '@/modules/front/ui/CardFront.vue';
    import InputText from '@/modules/front/ui/InputText.vue';
    import ListWrapper from '@/modules/front/ui/ListWrapper.vue';
    import ParcelaCard from '@/modules/front/perfil/components/ParcelaCard.vue';

    const {
        parcelas, loading, error, search, meta, page, perPage, fetchParcelas
    } = useParcelas();

    onMounted(() => { fetchParcelas(); });
</script>
